'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

exports.capitalize = capitalize;
//# sourceMappingURL=capitalize.js.map
